const Auth = {
  Auth: {
    region: 'eu-west-2', 
    userPoolId: 'eu-west-2_YI1qWRaFt',
    userPoolWebClientId: '7nhkt4a7fubq1l3ou3i4n3ignm',
    mandatorySignIn: 'true'
  }
};

export default Auth;